import { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import clsx from 'clsx'

const DEFAULT_POINTS = 100

const FacilAddPointsDialog = ({
  data = false,
  inProgress = false,
  title = '',
  text = '',
  inProgressButtonText = 'Please wait...',
  onClose = () => {},
  onConfirm = async () => {},
}) => {
  const [value, setValue] = useState(`${DEFAULT_POINTS}`)

  const handleValueChange = (e) => {
    setValue(e.target.value)
  }

  return (
    <Transition appear show={data !== null} as={Fragment} className="group">
      <Dialog as="div" className="relative z-10" onClose={() => null}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={clsx(
                  'group w-full max-w-sm transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-sm transition-all',
                  inProgress && 'inProgress'
                )}
              >
                <Dialog.Title
                  as="h3"
                  className="mb-5 text-center text-black-olive"
                  dangerouslySetInnerHTML={{ __html: title }}
                />
                <div className="mt-2">
                  <div
                    className="text-sm"
                    dangerouslySetInnerHTML={{ __html: text }}
                  />
                </div>

                {/** Adjust point form */}
                <div>
                  <input
                    name="bonus"
                    type="number"
                    placeholder="100"
                    min="0"
                    value={value}
                    className={clsx(
                      'mb-4 mr-4 w-full rounded-[4px] border-light-gray py-1 text-xs placeholder-dark-gray'
                    )}
                    onChange={handleValueChange}
                    onKeyDown={(event) => {
                      if (!/([0-9]|Backspace)/.test(event.key)) {
                        event.preventDefault()
                      }
                    }}
                  />
                </div>

                <div className="mt-4 text-right">
                  <button
                    type="button"
                    className="rounded-full border-2 border-skin-button-accent px-6 py-2 text-xs leading-none transition-colors group-[.inProgress]:cursor-not-allowed group-[.inProgress]:opacity-50 group-[:not(.inProgress)]:hover:bg-skin-button-accent group-[:not(.inProgress)]:hover:text-white group-[:not(.inProgress)]:active:translate-y-[0.75px] group-[:not(.inProgress)]:active:scale-[0.99]"
                    disabled={inProgress}
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="ml-2 inline-flex items-center rounded-full border-2 border-skin-button-accent bg-skin-button-accent px-6 py-2 text-xs leading-none text-white transition-colors group-[.inProgress]:cursor-not-allowed group-[.inProgress]:opacity-50 group-[:not(.inProgress)]:active:translate-y-[0.75px] group-[:not(.inProgress)]:active:scale-[0.99]"
                    disabled={inProgress}
                    onClick={async () => onConfirm(data, value)}
                  >
                    {inProgress ? inProgressButtonText : 'Apply'}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default FacilAddPointsDialog
